export default __webpack_public_path__ + "static/media/Vulkan - 18513.59c6e7a3.jpeg";